import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BasePopupComponent } from '../../common/base/base-popup.component';
import { PopupsManagerService } from '../../services/popups-manager.service';
import { Router } from '@angular/router';

export enum PurchaseInfoType {
  Warning,
  Success,
  Error,
}

export type PurchaseInfo = {
  title: string;
  text: string;
  subText: string;
  link: string;
};

@Component({
  selector: 'app-purchase-info-popup',
  templateUrl: './purchase-info-popup.component.html',
  styleUrls: ['./purchase-info-popup.component.scss'],
})
export class PurchaseInfoPopupComponent extends BasePopupComponent {
  @Input() type: PurchaseInfoType | undefined;
  @Input() info: PurchaseInfo | undefined;
  @Output() afterPopupClosed: EventEmitter<void> = new EventEmitter<void>();

  public PurchaseInfoType = PurchaseInfoType;

  constructor(
    popupsManagerService: PopupsManagerService,
    private router: Router
  ) {
    super(popupsManagerService);
  }

  public closePopup(): void {
    this.afterPopupClosed.emit();
    if (this.type === PurchaseInfoType.Success) {
      this.router.navigateByUrl('/');
    }
    super.closePopup();
  }
}
